/**
 * 计算 32 位 FNV-1a 哈希。
 *
 * @param str - 待哈希的字符串
 * @param seed - 哈希初始种子，默认 FNV offset basis 0x811c9dc5
 * @returns 无符号 32 位整数形式的哈希值
 * @see https://gist.github.com/vaiorabbit/5657561
 */
export function fnv32a(str: string, seed: number = 0x811c9dc5): number {
  let i: number, l: number
  let hval = seed

  for (i = 0, l = str.length; i < l; i++) {
    hval ^= str.charCodeAt(i)
    hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24)
  }

  return hval >>> 0
}
